
/* eslint-disable max-len */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import GlobalContext from './Context/GloablContext';
import { useLocation } from 'react-router-dom';

const MandatoryToast = ({ message, type, }) => {
    const ref=useRef()
    const [showToast, setShowToast] = useState(true);
    const location= useLocation()
    const {MandatoryErrorMessage,setMandatoryErrorMessage} = useContext(GlobalContext); 
    /* This `useEffect` hook is setting a timer using `setTimeout` function to hide the toast message
    after 5 seconds (5000 milliseconds) and also resetting the `toastMessage` state to an empty
    string. The `clearTimeout` function is used to clear the timer when the component unmounts. The
    empty dependency array `[]` ensures that this effect runs only once when the component mounts. */
    useEffect(() => {
        const timer = setTimeout(() => {
            setMandatoryErrorMessage('');
            setShowToast(false)
        }, 7000);
       

        return () => {
            clearTimeout(timer);

        };
    }, []);
   
    return (
        <>
            {showToast && MandatoryErrorMessage!=='' && (
                <AnimatePresence>
                    <div class="absolute mb-3 items-center w-fit right-4 top-[10px] left-[50%] -translate-x-[50%] z-[99] shadow-s2 rounded-lg data-[te-alert-show]:inline-flex add-error">
                        <motion.div
                            initial={{ y: -100 }}
                            ref={ref}
                            // ref={clickRef}
                            key={MandatoryErrorMessage}
                            animate={{ y: 0 }}
                            transition={{ duration: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={()=>{setMandatoryErrorMessage('')}}
                            role="alert" data-te-alert-init data-te-alert-dismiss aria-label="Close"
                    
                        >
                            <motion.div
                                initial={{ y: -100 }}
                                animate={{ y: 0 }}
                                exit={{ y: -100 }}
                                transition={{ duration: 1 }}

                                className="flex items-center justify-center border-[1.5px] border-[#F04438] bg-[#FFD6D3] rounded-[7px] cursor-pointer px-5 py-[18px]"
                            >
                                <span>
                                    <img
                                        loading="lazy"
                                        decoding="async"
                                        src="/images/error-icon.svg"
                                        alt="icon"
                                    />
                                </span>
                                <p className="text-f1 text-[#000000] font-normal pl-5">
                                    Please fill in all the mandatory fields
                                </p>
                            </motion.div>
                        </motion.div>
                    </div>
                </AnimatePresence>
            )}
        </>
    );
};

export default MandatoryToast;
